import CollaborationProcessCard from './CollaborationProcessCard';

export default CollaborationProcessCard;
